import { CircularProgress, Modal, Box, Checkbox, FormControlLabel } from "@mui/material";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import servTermoConsentimento from "../../../services/login/servTermoConsentimento";
import { linkStyle } from "../../../components/Inputs/Link";

const TermoConsentimento = ({ setOpenPopup, codigoTermo, termoConsendimentoDoc, linkTermoConsentimento, setDisableHome }) => {
    const [termoConsentimento, setTermoConsentimento] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const user = useSelector(state => state.user);

    const onClickAceitarTermos = async () => {
        try {
            setIsLoading(true);

            let dto = {
                CodigoResponsavel: user.codigoUsuario,
                TermoConsentimentoDoc: termoConsendimentoDoc,
                Nome: user.name,
                Email: user.email,
                DataAceite: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
                Aceito: 1
            }

            if(codigoTermo) {
                await servTermoConsentimento.alterarTermoConsentimento(codigoTermo, dto);
            } else {
                await servTermoConsentimento.cadastrarTermoConsentimento(dto);
            }

            setIsLoading(false);
            setOpenPopup(false);
            setDisableHome(false);
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    }

    const abrirTermos = async () => {
        const r = await fetch(linkTermoConsentimento);
        const blob = await r.blob();
        window.open(URL.createObjectURL(blob));
    }

    return (
        <div style={{ width: "100%", minWidth: "730px", maxWidth: "730px", height: "20%" }}>
            <h4>
                Informamos que realizamos uma alteração em nossos termos de consentimento.<br/> 
                Para continuar utilizando o Useall P3 Tec, é necessário aceitar os termos.<br/><br/>
                <div style={{ margin: '-10px 0',  display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                    <Checkbox 
                        sx={{
                            color: '#b8b8b8',
                            '&.Mui-checked': {
                                color: 'primary'
                            }
                        }}
                        onClick={() => setTermoConsentimento(!termoConsentimento)}
                        checked={termoConsentimento} 
                    />
                    <span style={{fontSize: '11px',  color: '#b8b8b8' }}>
                        Você concorda com os <a style={{...linkStyle, display: 'inline-block'}} onClick={() => abrirTermos()}>Termos de consentimento</a>?
                    </span>
                </div>
            </h4>

            <div style={{
                padding: "10px 45px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton disabled={!termoConsentimento} onClick={onClickAceitarTermos}>Aceitar termos</BlueHoverButton>
            </div>
            
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { TermoConsentimento };